import Button from "components/_button/form/submit"
import { selectStyles } from "constants/form"
import { SearchServiceItems } from 'constants/main'
import useCustomRouter from "hooks/useCustomRouter"
import { Dispatch, FC, FormEvent, SetStateAction, useCallback, useState } from "react"
import Select from 'react-select'
import 'react-toastify/dist/ReactToastify.css'
import IProjectCreate from "rules/interface/project/create.interface"
import styles from "./index.module.scss"
import { Alert, Text, Title } from "@mantine/core"

interface IError {
    service?: string
}


interface IProps {
    values: IProjectCreate
    setValues: Dispatch<SetStateAction<IProjectCreate>>
}


const ServiceTypeStep: FC<IProps> = ({ values, setValues }) => {

    const { push } = useCustomRouter()

    const [errors, setErrors] = useState<IError>({});

    const validationError = () => {
        let error: IError = {};
        let formIsValid = true;

        if (!values?.service) {
            formIsValid = false;
            error["service"] = "نوع سفارش خود را انتخاب کنید";
        }

        setErrors(error);
        return formIsValid;
    }


    const onSubmit = useCallback((e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        if (validationError()) {
            push("/contractors?looksForInstallment=true&workInInstallments=true", { preserveQuery: ["utm_source", "utm_campaign"] })
        }
    }, [values])




    return (
        <article className="flex flex-column gap-15">
            <Alert variant="light" color="success" py={8} title="درخواست شما با موفقیت ثبت شد" />

            <form onSubmit={onSubmit} className="flex flex-column gap-25">
                <section className="flex flex-column gap-15">
                    <div className={styles.form_item + " _validate relative input_block w100-mb flex flex-column jcc"}>
                        <label className={styles.wrapper__form_item}>
                            <span className={styles.label__wrapper}>نوع سفارش</span>
                            <Select
                                className={styles.select__wrapper + ` relative p-0 w100-mb ${errors?.service ? "input_error" : ""}`}
                                placeholder="نوع سفارش را انتخاب کنید."
                                getOptionLabel={(option: any) => option.title}
                                getOptionValue={(option: any) => option.title}
                                options={SearchServiceItems}
                                openMenuOnClick
                                value={values?.service}
                                isRtl
                                isSearchable
                                onChange={(val: any) => setValues(prev => ({ ...prev, service: val }))}
                                styles={{
                                    ...selectStyles,
                                    control: (base) => ({
                                        ...base,
                                        borderRadius: "8px",
                                        backgroundColor: "#FFF",
                                        paddingBlock: "4px",
                                        border: "none"
                                    }),
                                    placeholder: (base) => ({
                                        ...base,
                                        fontSize: "14px",
                                        fontWeight: 300,
                                        color: "#D9D9D9"
                                    })
                                }}
                                components={{
                                    IndicatorSeparator: null,
                                }}
                            />
                            {errors?.service && <span className="input_alert">{errors?.service}</span>}
                        </label>
                    </div>

                    <div className={styles.caption + " flex gap-5"}>
                        <span>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.99996 18.3333C14.5833 18.3333 18.3333 14.5833 18.3333 9.99996C18.3333 5.41663 14.5833 1.66663 9.99996 1.66663C5.41663 1.66663 1.66663 5.41663 1.66663 9.99996C1.66663 14.5833 5.41663 18.3333 9.99996 18.3333Z" stroke="#F57F22" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M10 6.66663V10.8333" stroke="#F57F22" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M9.99536 13.3334H10.0028" stroke="#F57F22" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </span>

                        <p>
                            در ادامه شما می توانید با مشاهده مشخصات متخصصین؛ متخصص مناسب خود را انتخاب کنید و یا با ثبت جزئیات پروژه انتخاب متخصص مناسب را به کارشناسان ما بسپارید.
                        </p>
                    </div>
                </section>

                <Button
                    type="submit"
                    className="flex align-i-center jcc gap-10"
                    loading={false}
                >
                    انتخاب متخصص
                </Button>
            </form>
        </article>
    )
}

export default ServiceTypeStep